import React, { useState } from "react";
import { X, UserRoundPlus, SquarePen, Trash } from "lucide-react";

const inputCls = "w-full px-3 py-2.5 rounded-xl bg-white border border-[#d1fae5] focus:border-[#2a3b19] outline-none text-sm";

/**
 * Add a note (and optional rating) for a SPECIFIC player.
 * evaluations: [{ player_id, rating, note }]
 * onSave(item) upserts by player_id. onRemove(player_id) removes.
 */
export default function PlayerNoteAdder({ players, evaluations = [], onSave, onRemove, testidPrefix = "eval" }) {
  const [open, setOpen] = useState(false);
  const [pid, setPid] = useState("");
  const [rating, setRating] = useState("");
  const [note, setNote] = useState("");

  const nameOf = (id) => players.find((p) => p.id === id)?.name || "لاعب";
  const reset = () => { setPid(""); setRating(""); setNote(""); };
  const startEdit = (ev) => { setPid(ev.player_id); setRating(ev.rating ?? ""); setNote(ev.note ?? ""); setOpen(true); };
  const submit = () => {
    if (!pid) return;
    onSave({ player_id: pid, rating, note });
    reset();
    setOpen(false);
  };

  return (
    <div>
      {!open ? (
        <button
          onClick={() => { reset(); setOpen(true); }}
          data-testid={`${testidPrefix}-add-open`}
          className="w-full py-2.5 rounded-xl bg-[#ecfdf5] hover:bg-[#d1fae5] text-[#2a3b19] font-medium flex items-center justify-center gap-2 border border-[#d1fae5]"
        >
          <UserRoundPlus size={16} /> إضافة ملاحظة للاعب
        </button>
      ) : (
        <div className="bg-[#f7fdfa] border border-[#d1fae5] rounded-xl p-4 space-y-3" data-testid={`${testidPrefix}-panel`}>
          <div className="flex items-center justify-between">
            <span className="font-semibold text-sm">اختر لاعباً وأضف ملاحظته</span>
            <button onClick={() => { setOpen(false); reset(); }}><X size={18} className="text-slate-500" /></button>
          </div>
          <select value={pid} onChange={(e) => setPid(e.target.value)} className={inputCls} data-testid={`${testidPrefix}-player`}>
            <option value="">— اختر اللاعب —</option>
            {players.map((p) => <option key={p.id} value={p.id}>{p.jersey_number ? `${p.jersey_number} - ` : ""}{p.name}</option>)}
          </select>
          <input type="number" min="0" max="100" placeholder="التقييم % (اختياري)" value={rating} onChange={(e) => setRating(e.target.value)} className={inputCls} data-testid={`${testidPrefix}-rating`} />
          <textarea placeholder="الملاحظة على اللاعب" value={note} onChange={(e) => setNote(e.target.value)} className={inputCls} rows={2} data-testid={`${testidPrefix}-note`} />
          <button onClick={submit} disabled={!pid} className="w-full py-2.5 rounded-xl bg-[#2a3b19] hover:bg-[#3a4f22] text-white font-bold disabled:opacity-50" data-testid={`${testidPrefix}-submit`}>
            حفظ الملاحظة
          </button>
        </div>
      )}

      <div className="space-y-2 mt-3">
        {evaluations.length === 0 && <p className="text-slate-500 text-sm text-center py-2">لا توجد ملاحظات على لاعبين بعد.</p>}
        {evaluations.map((ev) => (
          <div key={ev.player_id} className="bg-white border border-[#d1fae5] rounded-xl p-3" data-testid={`${testidPrefix}-row-${ev.player_id}`}>
            <div className="flex items-center justify-between">
              <span className="font-medium text-sm">{nameOf(ev.player_id)}</span>
              <div className="flex items-center gap-2">
                {ev.rating !== "" && ev.rating != null && <span className="text-xs font-bold text-[#2a3b19]">{ev.rating}%</span>}
                <button onClick={() => startEdit(ev)} className="text-slate-500 hover:text-[#2a3b19]"><SquarePen size={15} /></button>
                <button onClick={() => onRemove(ev.player_id)} className="text-red-500 hover:text-red-400" data-testid={`${testidPrefix}-remove-${ev.player_id}`}><Trash size={15} /></button>
              </div>
            </div>
            {ev.note && <p className="text-sm text-slate-700 mt-1">{ev.note}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
